import { cloneDeep } from 'lodash';
import { updateOwnerAndFarmCluster, updateOwnerData } from 'src/app/utils/states-management/actions/owner.action';
import { LoadingController, IonContent } from '@ionic/angular';
import { Farm } from './../../../models/farm/farm.model';
import { CAFE_IDS } from './../../../utils/consts';
import { RoutingConfig } from 'src/app/utils/routing-config';
import { ToastUtils } from 'src/app/utils/toast_builder';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { dev } from '../../../config/offlines_keys.json';
import { Router } from '@angular/router';
import { PopoverComponent } from 'src/app/widgets/popover/popover.component';
import routes from '../../../config/routing.json';
import { TranslateService } from '@ngx-translate/core';
import Owner from 'src/app/models/owner.model';
import { Store } from '@ngrx/store';
import { BehaviorSubject, lastValueFrom, take } from 'rxjs';
import {
  getAllCounties,
  getCountry,
} from 'src/app/utils/states-management/selector/countries.selector';
import { orderAlphabaticallyByAttribute, translateAndOrderAlphabaticallyByAttribute } from 'src/app/utils/array-filtrer';

@Component({
  selector: 'app-profile-info',
  templateUrl: './profile-info.component.html',
  styleUrls: ['./profile-info.component.scss'],
})
export class ProfileInfoComponent implements OnInit, OnDestroy {
  profile_info: any = {
    role: 'farmer',
    aaa_program: null,
    has_family: null,
    has_crop: true,
    cropConfig: [],
    head_household: null,
    farm_info: {
      farm_access_road_question: null,
      irrigation_system_question: null,
      water_access_question: null
    }
  };

  // Array of available roles for the profile
  roles = [
    { value: 'farmer', label: 'profile_info.farmer' },
    { value: 'agronom', label: 'profile_info.agronom', disabled: true },
    // { value: 'farmers_hub', label: 'profile_info.farmers_hub', disabled: true },
    // { value: 'network_manager', label: 'profile_info.network_manager', disabled: true },
  ];


  @ViewChild('content', { static: false }) content: IonContent;

  label;
  isDashboardView;
  country;
  has_showed_popover = false;
  formConfig;
  cropConfig;
  cropProducts = [];
  animalCrop;
  has_crop;
  submited;
  farm: any = new Farm();
  loadingModal;
  owner: Owner;
  ownerSubscription$;

  relationship_household = [
    { value: 'myself', label: 'myself' },
    { value: 'man.Wife', label: 'man.Wife' },
    { value: 'man.Child', label: 'man.Child' },
    { value: 'man.Dad', label: 'man.Dad' },
    { value: 'man.Brother', label: 'man.Brother' },
    { value: 'man.Grandfather', label: 'man.Grandfather' },
    { value: 'man.Uncle', label: 'man.Uncle' },
    { value: 'man.Nephew', label: 'man.Nephew' },
    { value: 'man.Cousin', label: 'man.Cousin' },
    { value: 'man.grandson', label: 'man.grandson' },
    { value: 'man.Great_grandfather', label: 'man.Great_grandfather' },
    { value: 'women.Husband', label: 'women.Husband' },
    { value: 'women.Daughter', label: 'women.Daughter' },
    { value: 'women.Mother', label: 'women.Mother' },
    { value: 'women.Sister', label: 'women.Sister' },
    { value: 'women.Grandmother', label: 'women.Grandmother' },
    { value: 'women.Aunt', label: 'women.Aunt' },
    { value: 'women.Niece', label: 'women.Niece' },
    { value: 'women.Cousin', label: 'women.Cousin' },
    { value: 'women.Granddaughter', label: 'women.Granddaughter' },
    { value: 'women.Great_grandmother', label: 'women.Great_grandmother' },
  ]
  constructor(
    private router: Router,
    private toastUtils: ToastUtils,
    public translateService: TranslateService,
    private routingConfig: RoutingConfig,
    private toastController: ToastUtils,
    private loadingController: LoadingController,
    private store: Store<{ farm: Farm; owner: Owner }>
  ) {
    this.ownerSubscription$ = this.store
      .select('owner')
      .subscribe((value: any) => {
        this.owner = cloneDeep(value);
        if (value.farm && value?.farm.id) this.farm = cloneDeep(value.farm);
      });
  }

  async handleChange(product: any, crop: any) {
    if (product.is_checked) {
      const productEntry = {
        id: product.crop_id,
        entity: product.crop_entity,
        crop_img: product.crop_img,
        hasPlotDetails: product.crops_form?.length > 0,
      };

      if (
        !this.cropProducts.some(
          (p) => p.id === productEntry.id && p.entity === productEntry.entity
        )
      ) {
        this.cropProducts.push(productEntry);
      }

      this.profile_info.has_crop = true;

      if (!product.crops_form) {
        const harvestedCrop = crop.products.find((p: any) => p.crops_form);
        if (harvestedCrop) {
          harvestedCrop.is_checked = true;
          const harvestedEntry = {
            id: harvestedCrop.crop_id,
            entity: harvestedCrop.crop_entity,
            crop_img: harvestedCrop.crop_img,
            hasPlotDetails: harvestedCrop.crops_form?.length > 0,
          };

          if (
            !this.cropProducts.some(
              (p) =>
                p.id === harvestedEntry?.id &&
                p.entity === harvestedEntry?.entity
            )
          ) {
            this.cropProducts.push(harvestedEntry);
          }
        }
      }
    } else {
      this.cropProducts = this.cropProducts.filter(
        (p) => !(p.id === product.crop_id && p.entity === product.crop_entity)
      );

      if (product.crops_form) {
        crop.products.forEach((p: any) => (p.is_checked = false));
        this.cropProducts = this.cropProducts.filter(
          (p) =>
            !crop.products.some(
              (cp: any) => cp.crop_id === p.id && cp.crop_entity === p.entity
            )
        );
      }

      if (!this.has_showed_popover) {
        // await this.showPopOver();
        this.has_showed_popover = true;
      }
    }

    this.profile_info.has_crop = this.cropProducts.length > 0;
  }

  handelProgChange(val) {
    this.profile_info.aaa_program = JSON.parse(val.target.value);
  }

  async ngOnInit() {

    this.loadingModal = await this.loadingController.create();
    // this.relationship_household = this.relationship_household.map((val)=>{

    // { value: 'myself', label: 'myself' },
    // })
    let array = this.relationship_household.map((value) => ({ value: value.value, label: this.translateService.instant(value.label) }))

    this.relationship_household = orderAlphabaticallyByAttribute(
      array,
      'label',
      this.translateService.currentLang
    );
    console.log(this.relationship_household)
    this.ownerSubscription$ = this.store.select('owner').subscribe(async (owner: any) => {

      let ClassName = 'ProfileInfoComponent';
      let config = await lastValueFrom(await this.routingConfig.getPageFormConfig(ClassName))
      this.formConfig = config?.fields
      this.roles = config?.props?.existing_role ? config?.props?.existing_role : this.roles
      this.cropConfig = await this.routingConfig.getCropFormConfig();
      console.log(this.roles)
      if (owner.farm && owner?.farm.id) this.farm = cloneDeep(owner.farm);

      this.owner = cloneDeep(owner);

      if (this.owner?.profile_info)
        this.profile_info = JSON.parse(this.owner?.profile_info);

      if (this.owner && this.cropConfig) {
        this.cropConfig.forEach((cat) => {
          cat.products.forEach((element) => {
            element['is_checked'] = this.profile_info?.cropConfig.find(
              (val) =>
                val?.id == element?.crop_id && val?.entity == element?.crop_entity
            ) || [6, 18, 19].includes(this.owner?.country_id)
              ? true
              : false;
            // element['is_checked'] = true
            this.handleChange(element, cat)
          });
        });

        // this.cropProducts = JSON.parse(this.owner?.profile_info)?.cropConfig;
      }
    })
    this.isDashboardView = this.router.url.includes(routes.dashboard.home);

    // if (this.cropProducts) {
    //   this.cropProducts?.forEach((crop) => {
    //     if (this.profile_info.cropConfig.find((val) => val.id === crop?.id)) {
    //       crop.is_checked = true;
    //     } else {
    //       crop.is_checked = false;
    //     }
    //   });
    // }

    this.has_showed_popover = false;
  }

  async goBack() {
    this.router.navigateByUrl(await this.routingConfig.getBackUrl());
  }

  async submitOwnerForm() {
    this.submited = true;
    console.log(this.cropProducts)
    this.profile_info.cropConfig = this.cropProducts;

    this.owner.profile_info = JSON.stringify(this.profile_info);

    let countrie = await lastValueFrom(
      this.store.select(getCountry).pipe(take(1))
    );

    this.owner.country_id = countrie?.id;
    if (
      (!this.farm?.cluster_number ||
        !this.farm?.cluster_id ||
        !this.farm?.ambassador_id) &&
      this.profile_info?.aaa_program
    ) {
      this.presentToast(
        await this.translateService.get('errors.all_fields').toPromise()
      );
      this.submited = false;
    } else {
      if (this.has_showed_popover || this.isDashboardView) {
        const farmId = this.farm?.id;
        const farmCluster_id = this.farm?.cluster_id;
        const farmCluster_number = this?.farm?.cluster_number;
        const farmAmbassador_id = this?.farm.ambassador_id;

        this.store.dispatch(
          updateOwnerAndFarmCluster({
            data: {
              farmId: farmId,
              clustId: farmCluster_id,
              clusterNumber: farmCluster_number,
              ambassadorId: farmAmbassador_id,
              owner_id: this.owner.id,
            },
            profile_info: this.owner.profile_info,
          })
        );
        if (!this.isDashboardView) {
          this.router.navigateByUrl(await this.routingConfig.getNextUrl());
        }
      } else this.showPopOver();
    }
  }
  changeRole(event) {
    console.log('changeRole', event.detail.value);
    this.profile_info.role = event.detail.value;
    this.owner.profile_info = JSON.stringify(this.profile_info);
    // this.store.dispatch(updateOwnerData({ owner: this.owner }))
  }
  async presentToast(message) {
    await this.toastController.toastBuilder('', 'bottom', message, 'danger');
  }

  async showPopOver(has_showed_popover = true) {
    let componentProps = {
      key1: await this.translateService.instant('info_bull'),
      close_button: await this.translateService.instant('submit'),
    };
    const popover = await this.toastUtils.popOverBuilder(
      componentProps,
      PopoverComponent,
      'popover-custom'
    );
    this.has_showed_popover = has_showed_popover;
    this.submited = false;
  }

  async submitFormDashboardViewForm() {
    this.submitOwnerForm();
  }

  ngOnDestroy(): void {
    // Clean up the subscription
    if (this.ownerSubscription$) {
      this.ownerSubscription$.unsubscribe();
    }
  }
}
